module.exports = __webpack_public_path__ + "img/IconCompare.0c92864e.svg";